module.exports = __webpack_public_path__ + "img/gini-coefficient.7bb6bcdf.svg";